/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import { TextInput } from "screens/perfilAutonomo/components/TextInput";
import { DefaultButton } from "screens/perfilAutonomo/components/defaultButton.component";
import { RiAddFill } from "react-icons/ri";
import { DatePicker } from "screens/perfilAutonomo/components/DatePicker";
import { ptBR } from "date-fns/locale";
import materialUI from "material-UI";
import { PrimaryButton } from "screens/perfilAutonomo/components/primaryButton.component";
import { BsTrash3Fill } from "react-icons/bs";
import { getListarTorres } from "services/api";
import { useEquipeUsuario } from "services/api/Admin_Hierarquia/equipe-por-usuario";
import CheckboxComponent from "components/CheckBoxG";
import { fName, fNO } from "screens/perfilAutonomo/utils";
import { fetchListarProdutos } from "screens/visitas/api/getListarProdutos";
import { toast } from "react-toastify";
import { postSolicitacao } from "screens/visitas/api/postSolicitacao";
import SelectComponent from "../../../../components/selectAutoCompleteG";
import * as S from "./modalNova.styles";
import * as SVGIcons from "../../../../assets/iconsSVG";
import {
  addButtonSx,
  defaultSolicitacaoData,
  solicitacaoDataTemplate,
  removeButtonSx,
  SolicitacaoData,
  TipoDocumentoOptions,
  TDocVisita,
  LocChaveVisita,
  DiasSemanaVisita,
} from "./utils";

const today = new Date();
today.setHours(0, 0, 0, 0);

export const ModalNovaSolicitacao = ({
  open,
  onClose,
  user,
  onDone,
}: {
  open: boolean;
  onClose: () => void;
  user: any;
  onDone: (idSolicitacaoVisita: string) => void;
}) => {
  const [data, setData] = useState<SolicitacaoData>(defaultSolicitacaoData);
  const [saving, setSaving] = useState(false);

  const [torreOptions, setTorreOptions] = useState<any>([]);

  const [minDate, setMinDate] = useState(today);

  const isCorretor =
    user?.codigoCargo2013 === "219.840.002" || // Corretor
    user?.codigoCargo2013 === "219.840.012" || // Coordenador Cia
    user?.codigoCargo2013 === "219.840.014"; // Coordenador Produto

  const { data: empreendimentosOptions, isLoading: loadingEmpreendimentos } =
    fetchListarProdutos(true);
  const { data: usuariosOptions, isLoading: loadingUsuarios } =
    useEquipeUsuario(user?.userId);

  useEffect(() => {
    const antc = empreendimentosOptions?.data?.find(
      (item: any) => item?.idEmpreendimento === data.idEmpreendimento
    )?.antecedenciaDeAgendamento;

    if (antc) {
      const newMinDate = new Date(today);
      newMinDate.setDate(newMinDate.getDate() + antc);
      setMinDate(newMinDate);
    } else {
      setMinDate(today);
    }
  }, [data.idEmpreendimento]);

  const sumData = (
    key: "cyrela" | "cliente" | "locais" | "veiculos",
    id?: number
  ) => {
    if (data[key].length >= 10 && !id) return;

    setData((prev) => {
      if (id) {
        return {
          ...prev,
          [key]: (prev[key] as Array<{ id: number }>).filter(
            (item) => item.id !== id
          ),
        };
      }

      return { ...prev, [key]: [...prev[key], solicitacaoDataTemplate[key]()] };
    });
  };

  const handleTipoDoc = (
    idUsuario: string,
    index: number,
    event: { label: string; value: number }
  ) => {
    const tipoDoc = event?.value;
    const user_ = usuariosOptions?.find(
      (item: any) => item?.idUsuario === idUsuario
    );

    let documento = "";
    if (tipoDoc === TDocVisita.CRECI) documento = user_?.creci ?? "";
    else if (index === 0 && isCorretor) {
      const user__ = usuariosOptions?.find(
        (item: any) => item?.idUsuario === user?.userId
      );
      if (tipoDoc === TDocVisita.CPF) documento = user__?.cpf ?? "";
      if (tipoDoc === TDocVisita.RG) documento = user__?.rg ?? "";
    }

    setData((prev) => ({
      ...prev,
      cyrela: prev.cyrela.map((item, i) =>
        i === index ? { ...item, tipoDocumento: tipoDoc, documento } : item
      ),
    }));
  };

  const handleTorres = (idEmpreendimento: string) => {
    const torres_ = (data_: any) => {
      setTorreOptions(
        data_?.map((item: any) => ({
          value: item?.id,
          label: item?.nome,
        }))
      );
    };

    getListarTorres(idEmpreendimento)
      .then(({ data }) => {
        if (data) torres_(data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleClose = () => {
    setTimeout(() => {
      setData(defaultSolicitacaoData);
    }, 250);
    onClose();
  };

  const handleSubmit = () => {
    setSaving(true);

    const cCyrela = data.cyrela.map((item, index) => {
      if (index === 0 && isCorretor) {
        return {
          ...item,
          nome: user?.name,
          idCorretor: user?.userId,
        };
      }
      return item;
    });

    const params = {
      idEmpreendimento: data.idEmpreendimento,
      /* eslint-disable @typescript-eslint/no-unused-vars */
      convidadosCyrelaCia: cCyrela.map(({ id, idCorretor, ...rest }) => ({
        ...rest,
        tipoDocumento: rest?.tipoDocumento as number,
        idUsuarioVisita: idCorretor as string,
      })),
      convidadosCliente: data.cliente.map(({ id, ...rest }) => rest),
      locais: data.locais.map(({ id, ...rest }) => rest),
      dadosVeiculo: data.veiculos.map(({ id, ...rest }) => rest),
      /* eslint-enable @typescript-eslint/no-unused-vars */
      dataAgendamento: data.dataAgendamento,
      horaInicioAgendamento:
        data.horaInicioAgendamento?.toLocaleTimeString("pt-BR", {
          hour12: false,
        }) ?? "",
      horaFimAgendamento:
        data.horaFimAgendamento?.toLocaleTimeString("pt-BR", {
          hour12: false,
        }) ?? "",
    };

    postSolicitacao(params)
      .then(({ success, data }) => {
        if (success) {
          toast.success("Solicitação realizada com sucesso");
          handleClose();
          onDone(data?.idSolicitacaoVisita);
        } else throw new Error();
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          error?.response?.data?.notifications?.[0]?.message ??
            "Erro ao criar solicitação, por favor tente novamente mais tarde."
        );
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const canSubmit = (): boolean => {
    if (!data.idEmpreendimento) return false;
    if (data.cyrela.length < 1) return false;
    if (
      data.cyrela.some(
        (item, index) =>
          !item.documento ||
          typeof item.tipoDocumento !== "number" ||
          (index !== 0 && !item.nome)
      )
    )
      return false;
    if (data.cliente.length < 1) return false;
    if (data.cliente.some((item) => !item.nome)) return false;
    if (torreOptions?.length !== 0) {
      if (data.locais.length < 1) return false;
      if (data.locais.some((item) => !item.idTorre || !item.unidade))
        return false;
    }
    if (!data.dataAgendamento || data.dataAgendamento < today) return false;
    if (!data.horaInicioAgendamento || !data.horaFimAgendamento) return false;
    return true;
  };

  return (
    <S.DialogContainer open={open} onClose={handleClose} maxWidth="md">
      <S.Container>
        <S.IconContainer>
          <div className="icon-wrapper">
            <RiAddFill color="#333" />
          </div>
          <h1 className="title center">{"Nova Solicitação"}</h1>
          <IoClose size={26} className="exit" onClick={handleClose} />
        </S.IconContainer>

        <S.Form>
          <S.Row template="1fr 1fr">
            <S.Field>
              <p>{"Empreendimento"}</p>
              <SelectComponent
                borderRadius="8px"
                data={
                  empreendimentosOptions?.data?.map((item: any) => ({
                    value: item?.idEmpreendimento,
                    label: item?.nomeEmpreendimento,
                  })) || []
                }
                value={empreendimentosOptions?.data
                  ?.map((item: any) => ({
                    value: item?.idEmpreendimento,
                    label: item?.nomeEmpreendimento,
                  }))
                  ?.find((item: any) => item?.value === data.idEmpreendimento)}
                onChange={(event: { label: string; value: string }) => {
                  if (event) handleTorres(event?.value);
                  setData((prev) => ({
                    ...prev,
                    idEmpreendimento: event?.value,
                  }));
                }}
                disabled={
                  loadingEmpreendimentos || !empreendimentosOptions?.data
                }
              />
            </S.Field>
            {data.idEmpreendimento ? (
              <S.Field>
                <p>{"Localização da Chave"}</p>
                <TextInput
                  placeholder=""
                  value={
                    LocChaveVisita[
                      empreendimentosOptions?.data?.find(
                        (item: any) =>
                          item?.idEmpreendimento === data.idEmpreendimento
                      )?.localizacaoChave
                    ]
                  }
                  lockIcon
                  readOnly
                />
              </S.Field>
            ) : null}
          </S.Row>

          <S.Section>{"Convidados Cyrela"}</S.Section>

          <S.Block>
            {data.cyrela.map((item, index) => (
              <S.Convidados key={item.id}>
                <S.Row template="3fr 3fr 3fr 1fr">
                  {!isCorretor && !item.corretorParceiro && (
                    <S.Field>
                      <p>{"Corretor/Cord. Cyr & Cia"}</p>
                      <SelectComponent
                        borderRadius="8px"
                        data={
                          usuariosOptions
                            ? usuariosOptions
                                ?.filter(
                                  (item: any) =>
                                    !data.cyrela.some(
                                      (cyrelaItem) =>
                                        cyrelaItem.idCorretor ===
                                        item?.idUsuario
                                    )
                                )
                                ?.map((item: any) => ({
                                  value: item?.idUsuario,
                                  label: item?.nomeUsuario,
                                }))
                            : []
                        }
                        value={
                          usuariosOptions
                            ? usuariosOptions
                                ?.map((item: any) => ({
                                  value: item?.idUsuario,
                                  label: item?.nomeUsuario,
                                }))
                                ?.find(
                                  (i: any) =>
                                    i.value === data.cyrela[index].idCorretor
                                )
                            : { value: "", label: "" }
                        }
                        onChange={(event: { label: string; value: string }) => {
                          setData((prev) => ({
                            ...prev,
                            cyrela: prev.cyrela.map((item) => {
                              if (item.id === data.cyrela[index].id) {
                                return {
                                  ...item,
                                  nome: event?.label,
                                  idCorretor: event?.value,
                                  tipoDocumento: null,
                                  documento: "",
                                };
                              }
                              return item;
                            }),
                          }));
                        }}
                        disabled={loadingUsuarios || !usuariosOptions}
                      />
                    </S.Field>
                  )}
                  {!isCorretor && item?.corretorParceiro && (
                    <S.Field>
                      <p>{"Corretor Parceiro"}</p>
                      <TextInput
                        value={data.cyrela[index].nome}
                        onChange={(val) => {
                          setData((prev) => ({
                            ...prev,
                            cyrela: prev.cyrela.map((item) => {
                              if (item.id === data.cyrela[index].id) {
                                return { ...item, nome: val };
                              }
                              return item;
                            }),
                          }));
                        }}
                      />
                    </S.Field>
                  )}
                  {isCorretor &&
                    (index === 0 ? (
                      <S.Field>
                        <p>{"Corretor/Cord. Cyr & Cia"}</p>
                        {!item?.corretorParceiro ? (
                          <TextInput value={user?.name} readOnly lockIcon />
                        ) : (
                          <TextInput
                            value={data.cyrela[index].nome}
                            onChange={(val) => {
                              setData((prev) => ({
                                ...prev,
                                cyrela: prev.cyrela.map((item) => {
                                  if (item.id === data.cyrela[index].id) {
                                    return { ...item, nome: val };
                                  }
                                  return item;
                                }),
                              }));
                            }}
                          />
                        )}
                      </S.Field>
                    ) : index > 0 && item.corretorParceiro ? (
                      <S.Field>
                        <p>{"Corretor Parceiro"}</p>
                        <TextInput
                          value={data.cyrela[index].nome}
                          onChange={(val) => {
                            setData((prev) => ({
                              ...prev,
                              cyrela: prev.cyrela.map((item) => {
                                if (item.id === data.cyrela[index].id) {
                                  return { ...item, nome: val };
                                }
                                return item;
                              }),
                            }));
                          }}
                        />
                      </S.Field>
                    ) : (
                      <S.Field>
                        <p>{"Corretor/Cord. Cyr & Cia"}</p>
                        <SelectComponent
                          borderRadius="8px"
                          data={
                            usuariosOptions
                              ? usuariosOptions
                                  ?.filter(
                                    (item: any) =>
                                      !data.cyrela.some(
                                        (cyrelaItem) =>
                                          cyrelaItem.idCorretor ===
                                          item?.idUsuario
                                      )
                                  )
                                  ?.map((item: any) => ({
                                    value: item?.idUsuario,
                                    label: item?.nomeUsuario,
                                  }))
                              : []
                          }
                          value={
                            usuariosOptions
                              ? usuariosOptions
                                  ?.map((item: any) => ({
                                    value: item?.idUsuario,
                                    label: item?.nomeUsuario,
                                  }))
                                  ?.find(
                                    (i: any) =>
                                      i.value === data.cyrela[index].idCorretor
                                  )
                              : { value: "", label: "" }
                          }
                          onChange={(event: {
                            label: string;
                            value: string;
                          }) => {
                            setData((prev) => ({
                              ...prev,
                              cyrela: prev.cyrela.map((item) => {
                                if (item.id === data.cyrela[index].id) {
                                  return {
                                    ...item,
                                    nome: event?.label,
                                    idCorretor: event?.value,
                                    tipoDocumento: null,
                                    documento: "",
                                  };
                                }
                                return item;
                              }),
                            }));
                          }}
                          disabled={loadingUsuarios || !usuariosOptions}
                        />
                      </S.Field>
                    ))}
                  <S.Field>
                    <p>{"Tipo Doc."}</p>
                    <SelectComponent
                      borderRadius="8px"
                      data={TipoDocumentoOptions}
                      value={TipoDocumentoOptions.find(
                        (i) => i.value === data.cyrela[index].tipoDocumento
                      )}
                      onChange={(event: { label: string; value: number }) => {
                        handleTipoDoc(
                          data.cyrela[index].idCorretor,
                          index,
                          event
                        );
                      }}
                    />
                  </S.Field>
                  {typeof data?.cyrela?.find((i) => i?.id === item?.id)
                    ?.tipoDocumento === "number" ? (
                    <S.Field>
                      <p>
                        {TipoDocumentoOptions.find(
                          (i_) =>
                            i_.value ===
                            data?.cyrela?.find((i) => i?.id === item?.id)
                              ?.tipoDocumento
                        )?.label?.split(" ")?.[0] ?? "Doc."}
                      </p>
                      <TextInput
                        placeholder=""
                        value={data.cyrela[index].documento}
                        onChange={(val) => {
                          setData((prev) => ({
                            ...prev,
                            cyrela: prev.cyrela.map((item) => {
                              if (item.id === data.cyrela[index].id) {
                                return {
                                  ...item,
                                  documento: fNO(val),
                                };
                              }
                              return item;
                            }),
                          }));
                        }}
                      />
                    </S.Field>
                  ) : (
                    <div id="dummy" style={{ width: "100%" }} />
                  )}
                  <S.Field
                    style={{ height: "100%", justifyContent: "flex-end" }}
                  >
                    {index === 0 ? (
                      <DefaultButton
                        onClick={() => sumData("cyrela")}
                        style={addButtonSx}
                        content={<RiAddFill size={22} />}
                        disabled={data.cyrela.length >= 10}
                      />
                    ) : (
                      <DefaultButton
                        onClick={() => sumData("cyrela", item.id)}
                        style={removeButtonSx}
                        content={<BsTrash3Fill size={22} color={"#F43636"} />}
                      />
                    )}
                  </S.Field>
                </S.Row>

                {((isCorretor && index !== 0) || !isCorretor) && (
                  <div style={{ width: "100%" }}>
                    <CheckboxComponent
                      label="Parceiro"
                      checked={item?.corretorParceiro}
                      onChange={(e) => {
                        setData((prev) => ({
                          ...prev,
                          cyrela: prev.cyrela.map((item) => {
                            if (item.id === data.cyrela[index].id) {
                              return {
                                ...item,
                                nome: "",
                                idCorretor: "",
                                tipoDocumento: null,
                                corretorParceiro: e.target.checked,
                              };
                            }
                            return item;
                          }),
                        }));
                      }}
                    />
                  </div>
                )}
              </S.Convidados>
            ))}
          </S.Block>

          <S.Section>{"Convidados Clientes"}</S.Section>

          <S.Block>
            {data.cliente.map((item, index) => (
              <S.Row key={item.id} template="9fr 1fr">
                <S.Field>
                  <p>{"Nome Completo do Cliente"}</p>
                  <TextInput
                    placeholder=""
                    onChange={(val) => {
                      setData((prev) => ({
                        ...prev,
                        cliente: prev.cliente.map((c) =>
                          c.id === item.id ? { ...c, nome: fName(val) } : c
                        ),
                      }));
                    }}
                    value={item.nome}
                  />
                </S.Field>
                <S.Field style={{ height: "100%", justifyContent: "flex-end" }}>
                  {index === 0 ? (
                    <DefaultButton
                      onClick={() => sumData("cliente")}
                      style={addButtonSx}
                      content={<RiAddFill size={22} />}
                      disabled={data.cliente.length >= 10}
                    />
                  ) : (
                    <DefaultButton
                      onClick={() => sumData("cliente", item.id)}
                      style={removeButtonSx}
                      content={<BsTrash3Fill size={22} color={"#F43636"} />}
                    />
                  )}
                </S.Field>
              </S.Row>
            ))}
          </S.Block>

          <S.Section>{"Locais"}</S.Section>

          <S.Block>
            {data.locais.map((item, index) => (
              <S.Row key={item.id} template="4.5fr 4.5fr 1fr">
                <S.Field>
                  <p>{"Torre"}</p>
                  <SelectComponent
                    borderRadius="8px"
                    data={torreOptions}
                    value={torreOptions?.find(
                      (i: any) => i?.value === data?.locais[index]?.idTorre
                    )}
                    onChange={(event: { label: string; value: string }) => {
                      setData((prev) => ({
                        ...prev,
                        locais: prev.locais.map((item) => {
                          if (item.id === data.locais[index].id) {
                            return {
                              ...item,
                              unidade: "",
                              idTorre: event?.value ?? "",
                              torre: event?.label ?? "",
                            };
                          }
                          return item;
                        }),
                      }));
                    }}
                    disabled={!torreOptions || torreOptions.length === 0}
                  />
                </S.Field>
                <S.Field>
                  <p>{"Unidade"}</p>
                  <TextInput
                    placeholder=""
                    onChange={(val) => {
                      setData((prev) => ({
                        ...prev,
                        locais: prev.locais.map((c) =>
                          c.id === item.id ? { ...c, unidade: fNO(val) } : c
                        ),
                      }));
                    }}
                    value={data.locais[index].unidade}
                    maxLength={8}
                    matchDisabled
                    disabled={!data.locais[index].torre}
                  />
                </S.Field>
                <S.Field style={{ height: "100%", justifyContent: "flex-end" }}>
                  {index === 0 ? (
                    <DefaultButton
                      onClick={() => sumData("locais")}
                      style={addButtonSx}
                      content={<RiAddFill size={22} />}
                      disabled={data.locais.length >= 10}
                    />
                  ) : (
                    <DefaultButton
                      onClick={() => sumData("locais", item.id)}
                      style={removeButtonSx}
                      content={<BsTrash3Fill size={22} color={"#F43636"} />}
                    />
                  )}
                </S.Field>
              </S.Row>
            ))}
          </S.Block>

          {empreendimentosOptions?.data?.find(
            (i: any) => i?.idEmpreendimento === data?.idEmpreendimento
          )?.aceitaVeiculo && (
            <>
              <S.Section>{"Veículos"}</S.Section>

              <S.Block>
                {data.veiculos.map((item, index) => (
                  <S.Row key={item.id} template="4.5fr 4.5fr 1fr">
                    <S.Field>
                      <p>{"Veículo"}</p>
                      <TextInput
                        placeholder=""
                        onChange={(val) => {
                          setData((prev) => ({
                            ...prev,
                            veiculos: prev.veiculos.map((c) =>
                              c.id === item.id ? { ...c, veiculo: val } : c
                            ),
                          }));
                        }}
                        value={data.veiculos[index].veiculo}
                        maxLength={50}
                      />
                    </S.Field>
                    <S.Field>
                      <p>{"Placa"}</p>
                      <TextInput
                        placeholder="Ex.: ABC1D23"
                        onChange={(val) => {
                          setData((prev) => ({
                            ...prev,
                            veiculos: prev.veiculos.map((c) =>
                              c.id === item.id ? { ...c, placa: val } : c
                            ),
                          }));
                        }}
                        value={data.veiculos[index].placa}
                        maxLength={7}
                      />
                    </S.Field>
                    <S.Field
                      style={{ height: "100%", justifyContent: "flex-end" }}
                    >
                      {index === 0 ? (
                        <DefaultButton
                          onClick={() => sumData("veiculos")}
                          style={addButtonSx}
                          content={<RiAddFill size={22} />}
                          disabled={data.veiculos.length >= 10}
                        />
                      ) : (
                        <DefaultButton
                          onClick={() => sumData("veiculos", item.id)}
                          style={removeButtonSx}
                          content={<BsTrash3Fill size={22} color={"#F43636"} />}
                        />
                      )}
                    </S.Field>
                  </S.Row>
                ))}
              </S.Block>
            </>
          )}

          <S.Section>{"Agendamento"}</S.Section>

          {data.idEmpreendimento && (
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              <p>
                {"Dias disponíveis: "}
                <span>
                  {empreendimentosOptions?.data
                    ?.find(
                      (item: any) =>
                        item?.idEmpreendimento === data.idEmpreendimento
                    )
                    ?.diasDisponiveis?.map(
                      (item: number) => DiasSemanaVisita[item]
                    )
                    .join(", ")}
                </span>
              </p>

              <p>
                {"Horários disponíveis (dias da semana): "}
                <span>
                  {empreendimentosOptions?.data
                    ?.find(
                      (item: any) =>
                        item?.idEmpreendimento === data.idEmpreendimento
                    )
                    ?.horaInicioDiaDaSemana?.substring(0, 5)}
                  {" às "}
                  {empreendimentosOptions?.data
                    ?.find(
                      (item: any) =>
                        item?.idEmpreendimento === data.idEmpreendimento
                    )
                    ?.horaFimDiaDaSemana?.substring(0, 5)}
                </span>
              </p>

              {empreendimentosOptions?.data
                ?.find(
                  (item: any) =>
                    item?.idEmpreendimento === data.idEmpreendimento
                )
                ?.diasDisponiveis?.some(
                  (dia: number) =>
                    dia === DiasSemanaVisita["Sábado"] ||
                    dia === DiasSemanaVisita.Domingo
                ) && (
                <p>
                  {"Horários disponíveis (final de semana): "}
                  <span>
                    {empreendimentosOptions?.data
                      ?.find(
                        (item: any) =>
                          item?.idEmpreendimento === data.idEmpreendimento
                      )
                      ?.horaInicioFinalDeSemana?.substring(0, 5) ?? "--:--"}
                    {" às "}
                    {empreendimentosOptions?.data
                      ?.find(
                        (item: any) =>
                          item?.idEmpreendimento === data.idEmpreendimento
                      )
                      ?.horaFimFinalDeSemana?.substring(0, 5) ?? "--:--"}
                  </span>
                </p>
              )}

              {!!empreendimentosOptions?.data?.find(
                (item: any) => item?.idEmpreendimento === data.idEmpreendimento
              )?.antecedenciaDeAgendamento && (
                <p style={{ color: "red" }}>
                  {"Empreendimento com prévia antecedência de: "}
                  <span style={{ color: "red", fontWeight: "bold" }}>
                    {`${
                      empreendimentosOptions?.data?.find(
                        (item: any) =>
                          item?.idEmpreendimento === data.idEmpreendimento
                      )?.antecedenciaDeAgendamento
                    } ${
                      empreendimentosOptions?.data?.find(
                        (item: any) =>
                          item?.idEmpreendimento === data.idEmpreendimento
                      )?.antecedenciaDeAgendamento === 1
                        ? "dia"
                        : "dias"
                    }`}
                  </span>
                </p>
              )}
            </div>
          )}

          <S.Block>
            <S.Row template="1fr 1fr">
              <S.Field>
                <p>{"Data"}</p>
                <DatePicker
                  onChange={(val) => {
                    setData((prev) => ({
                      ...prev,
                      dataAgendamento: val,
                    }));
                  }}
                  value={data.dataAgendamento}
                  minDate={minDate}
                />
              </S.Field>
              <S.Field>
                <p>{"Hora"}</p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 12,
                  }}
                >
                  <S.LocalizationProvider
                    adapterLocale={ptBR}
                    dateAdapter={materialUI.AdapterDateFns}
                  >
                    <S.TimePicker
                      inputFormat="HH:mm"
                      ampm
                      value={data.horaInicioAgendamento}
                      components={{
                        OpenPickerIcon: SVGIcons.ClockIcon,
                      }}
                      InputAdornmentProps={{ position: "end" }}
                      onChange={(val: any) =>
                        setData((prev) => ({
                          ...prev,
                          horaInicioAgendamento: val,
                        }))
                      }
                      renderInput={(params: any) => (
                        <>
                          <S.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                          />
                        </>
                      )}
                    />
                  </S.LocalizationProvider>

                  <p>{"às"}</p>

                  <S.LocalizationProvider
                    adapterLocale={ptBR}
                    dateAdapter={materialUI.AdapterDateFns}
                  >
                    <S.TimePicker
                      inputFormat="HH:mm"
                      ampm
                      value={data.horaFimAgendamento}
                      components={{
                        OpenPickerIcon: SVGIcons.ClockIcon,
                      }}
                      InputAdornmentProps={{ position: "end" }}
                      onChange={(val: any) =>
                        setData((prev) => ({
                          ...prev,
                          horaFimAgendamento: val,
                        }))
                      }
                      renderInput={(params: any) => (
                        <>
                          <S.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                          />
                        </>
                      )}
                    />
                  </S.LocalizationProvider>
                </div>
              </S.Field>
            </S.Row>
          </S.Block>

          <div id="dummy" style={{ marginBottom: 30 }} />
        </S.Form>

        <S.Buttons>
          <PrimaryButton
            content={saving ? "Solicitando..." : "Solicitar"}
            onClick={handleSubmit}
            disabled={!canSubmit() || saving}
          />
        </S.Buttons>
      </S.Container>
    </S.DialogContainer>
  );
};
